var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('small',{staticClass:"recaptcha-terms"},[_vm._v("Este site é protegido pelo reCAPTCHA e a "),_c('a',{staticClass:"link",attrs:{"href":"https://policies.google.com/privacy"}},[_vm._v("Política de Privacidade")]),_vm._v(" e os "),_c('a',{staticClass:"link",attrs:{"href":"https://policies.google.com/terms"}},[_vm._v("Termos de Serviço do Google")]),_vm._v(" se aplicam")])
}]

export { render, staticRenderFns }